import React from 'react';
import moment from 'moment';
import { formatCurrency, statusTextColorMapping } from 'libs';
import styles from './products.module.scss';
import cx from 'classname';
import { CaretRightIcon } from 'components/icons';
import { useHistory } from 'react-router';
import Badge from 'components/Badge';

const ProductGridView = ({ products, testid }) => {
  const history = useHistory();
  const view = (code) => {
    history.push(`/products/view/${code}`);
  };
  return (
    <div className={styles.productDiv} data-testid={testid}>
      {products &&
        products.length > 0 &&
        products.map((item, index) => (
          <div className={styles.product} key={index}>
            <div className={styles.row}>
              <p className={styles.productTitle}>
                {item.title.substring(0, 15)}...
              </p>

              <Badge color={statusTextColorMapping[item.status]?.color}>
                {statusTextColorMapping[item.status]?.text}
              </Badge>
            </div>

            <div>
              <p className={styles.description}>
                {item.description.substring(0, 32)}...
              </p>
            </div>
            <hr className={styles.line} style={{ marginBottom: '15px' }} />

            <div className={cx(styles.dateGrid)}>
              <div>
                <p className={cx(styles.datesTitle)}>Date Created</p>
                <p className={cx(styles.datesValue)}>
                  {moment(item.createdAt).format('MMM D, YYYY LT')}
                </p>
              </div>

              <div>
                <p className={cx(styles.datesTitle, styles.dateCreated)}>
                  Date Updated
                </p>
                <p className={cx(styles.datesValue)}>
                  {moment(item.updatedAt).format('MMM D, YYYY LT')}
                </p>
              </div>
            </div>

            <div className={styles.amountTitle}>
              <p>Amount</p>
            </div>

            <div className={cx(styles.row, styles.amountValue)}>
              <p className={styles.amount}>
                {item.amount ? formatCurrency(item.amount) : item.amountType}
              </p>
              <div>
                <p
                  className={styles.view}
                  onClick={() => view(item.code)}
                  data-testid="click-details"
                >
                  View
                  <CaretRightIcon
                    fill="#18379A"
                    style={{ marginLeft: '2px' }}
                  />
                </p>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ProductGridView;
